"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenHyperlinkCommand = void 0;
var tslib_1 = require("tslib");
var change_field_hyperlink_info_history_item_1 = require("../../../core/model/history/items/change-field-hyperlink-info-history-item");
var url_1 = require("@devexpress/utils/lib/utils/url");
var i_rich_edit_core_1 = require("../../interfaces/i-rich-edit-core");
var client_command_1 = require("../client-command");
var command_base_1 = require("../command-base");
var hyperlink_command_base_1 = require("./hyperlink-command-base");
var utils_1 = require("../../../base-utils/utils");
var OpenHyperlinkCommand = (function (_super) {
    tslib_1.__extends(OpenHyperlinkCommand, _super);
    function OpenHyperlinkCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenHyperlinkCommand.prototype.executeCore = function (state, options) {
        var field;
        if (options.param)
            field = options.param;
        else {
            if (!state.visible)
                return false;
            field = state.value;
        }
        var hyperlinkInfo = field.getHyperlinkInfo();
        var fieldIsEditable = this.selection.activeSubDocument.isEditable([field.getAllFieldInterval()]);
        if (!hyperlinkInfo.visited && this.control.readOnly != i_rich_edit_core_1.ReadOnlyMode.Persistent && fieldIsEditable) {
            var newHyperlinkInfo = hyperlinkInfo.clone();
            newHyperlinkInfo.visited = true;
            this.history.beginTransaction();
            this.history.addAndRedo(new change_field_hyperlink_info_history_item_1.ChangeFieldHyperlinkInfoHistoryItem(this.modelManipulator, this.selection.activeSubDocument, field.index, newHyperlinkInfo));
            this.history.endTransaction();
            this.control.serverDispatcher.forceSendingRequest();
        }
        if (hyperlinkInfo.anchor)
            this.control.commandManager.getCommand(client_command_1.RichEditClientCommand.GoToBookmark)
                .execute(this.control.commandManager.isPublicApiCall, new command_base_1.CommandSimpleOptions(this.control, hyperlinkInfo.anchor));
        else {
            var url = utils_1.UrlUtils.isValid(hyperlinkInfo.uri) ? hyperlinkInfo.uri : utils_1.UrlUtils.EmptyPage;
            url_1.Url.navigate(url, "_blank");
        }
        return true;
    };
    OpenHyperlinkCommand.prototype.isEnabledInReadOnlyMode = function () {
        return true;
    };
    return OpenHyperlinkCommand;
}(hyperlink_command_base_1.HyperlinkCommandBase));
exports.OpenHyperlinkCommand = OpenHyperlinkCommand;
